module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Fc-Ga-Hc-Ia.a6968dce.png";